import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-footer.html',
  styleUrls: ['./app-footer.scss']
})
export class AppFooterComponent {
  currentYear = new Date().getFullYear();
  appVersion  = environment.appVersion;
}
